import { type AppName } from '../app-config-context/types';

import { type ProductNameLegion } from './types';

export const mapAppNameToProduct: Record<Exclude<AppName, null>, ProductNameLegion> = {
	'': 'STANDALONE',
	'site-directory': 'STANDALONE',
	'confluence-directory': 'CONFLUENCE',
	'jira-directory': 'JIRA',
	'teamcentral-directory': 'TOWNSQUARE',
	'home-directory': 'HOME',
};
